import PropTypes from 'prop-types';
import { Box, Typography } from '@material-ui/core';

import {
  Page,
  Link,
  Logo,
} from 'components';
import { useBreakpoint } from 'hooks';
import { BUILD_VERSION } from 'settings';
import { getSettings } from 'utils/settings';

import useStyles from './styles';

function LayoutAuth({ children }) {
  // Se lee en render (no al importar el módulo): para entonces
  // initSettings ya corrió y la config del dominio está en cache.
  const waves = getSettings('site.waves') || '/static/images/bgpinpeo.svg';
  const classes = useStyles({ waves });
  const isMobile = ['sm', 'xs'].includes(useBreakpoint());
  const configWidth = getSettings('logo.width');

  return (
    <div className={classes.root}>
      <Box className={classes.mainContent}>
        <Page
          className={classes.pageContainer}
          style={{
            backgroundColor:
              'transparent',
          }}
        >
          <Box className={classes.contentCenter}>
            <Box mb={4}>
              <Logo style={{
                maxHeight: isMobile ? 24 : (configWidth ?? 38),
              }} variant='imagotipo' />
            </Box>

            {children}
          </Box>
        </Page>
      </Box>

      <footer className={classes.footer}>
        <Box className={classes.footerContent}>
          <Typography variant="caption" className={classes.versionText}>
            {`Versión ${BUILD_VERSION}`}
          </Typography>

          <Box className={classes.linksContainer}>
            <Link
              to="https://pinpeo.com/terminos-y-condiciones.html"
              variant="external"
              className={classes.footerLink}
            >
              Términos y condiciones
            </Link>

            <Link
              to="https://pinpeo.com/aviso-de-privacidad.html"
              variant="external"
              className={classes.footerLink}
            >
              Aviso de privacidad
            </Link>
          </Box>
        </Box>
      </footer>
    </div>
  );
};

LayoutAuth.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default LayoutAuth;
